import { register, load, getInstances } from '@shopify/theme-sections';
import 'swiper/swiper-bundle.css';
import Swiper, { Navigation, Pagination, Autoplay, A11y } from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay, A11y]);
Avatar.theme = Avatar.theme || {};
Avatar.theme.sections = Avatar.theme.sections || {};
var sectionName = 'slideshow';

Avatar.theme.sections.Slideshow = function Slideshow() {
  var selectors = {
    slideshow: '[data-slideshow]',
    slideshowSlide: function slideshowSlide(id) {
      return "[data-slideshow-slide=\"".concat(id, "\"]");
    }
  };
  register(sectionName, {
    onLoad: function onLoad() {
      var container = this.container;
      this.slideshows = container.querySelectorAll(selectors.slideshow);
      this.swipers = [];
      this.autoHeight = this.slideshows[0].dataset.swiperAutoheight;

      if (this.slideshows.length > 0) {
        this.initSlideshow();
      }
    },
    onBlockSelect: function onBlockSelect(evt) {
      this.swipers.forEach(function (swiper) {
        var i = swiper.el.querySelector(selectors.slideshowSlide(evt.detail.blockId)).getAttribute('data-index');
        swiper.slideTo(i);
        swiper.autoplay.stop();
      });
    },
    onBlockDeselect: function onBlockDeselect() {
      this.swipers.forEach(function (swiper) {
        return swiper.autoplay.start();
      });
    },
    initSlideshow: function initSlideshow() {
      var _this = this;

      this.slideshows.forEach(function (slideshow) {
        return _this.swipers.push(_this.swiperInstance(slideshow));
      });
    },
    swiperInstance: function swiperInstance(selector) {
      return new Swiper(selector, {
        observer: true,
        observeParents: true,
        loop: true,
        preloadImages: false,
        autoHeight: this.autoHeight,
        speed: 700,
        autoplay: {
          delay: 1000000
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        a11y: {
          prevSlideMessage: 'Previous slide',
          nextSlideMessage: 'Next slide',
          paginationBulletMessage: 'Go to slide {{index}}'
        },
        breakpoints: {
          640: {
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev'
            }
          }
        }
      });
    },
    onUnload: function onUnload() {
      this.swipers.forEach(function (swiper) {
        return swiper.destroy();
      });
    }
  });
  load(sectionName);
  var instance = getInstances(sectionName);
  return instance[0];
}();